import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {Col, Row} from "react-bootstrap";

import Objects from "../utils/Objects";
import EPCLink from "../component/Asset/EPCLink";
import {dayMonthYearAtTime} from "../utils/dates";
import DispositionSelector from "../disposition/DispositionSelector";
import BizStepSelector from "../component/BizStep/BizStepSelector";
import ProductTypeSelector from "../productType/component/ProductTypeSelector";
import BizLocationSelector from "../component/BizLocation/BizLocationSelector";
import BreadcrumbItem from '../component/BreadcrumbItem/BreadcrumbItem';

export default class AssetGrid extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      itemsSelected: [],
      allItems: []
    }
    this.handleChange = this.handleChange.bind(this)
    this.selectAll = this.selectAll.bind(this)
  }

  title = "Estoque";

  defaultSort = "currentState.stateDate";

  exportNewPage = true;

  showPdfButton = false;

  customBreadcrumbs = [<BreadcrumbItem key={1} title="Estoque"/>]

  showNewButton = false;

  refreshState = null;

  customFilters = {
    dispositionsId: sessionStorage.getItem('dispositionsId'),
    bizStepsId: sessionStorage.getItem('bizStepsId'),
    productTypesId: sessionStorage.getItem('productTypesId'),
    bizLocationsId: sessionStorage.getItem('bizLocationsId')
  }

  onData(data) {
    this.state.allItems = data.content.map(x => x.asset)
    this.setState({allItems: this.state.allItems})
    this.refreshState && this.refreshState()
  }

  customFilterComponent = (props, state, onChange) => {
    return (
      <div>
        <Row>
          <Col md={3}>
            <BizLocationSelector
              defaultValue={this.customFilters.bizLocationsId}
              multiple
              setValue={value => {
                this.customFilters.bizLocationsId = value.map(x => x.id)
                sessionStorage.setItem('bizLocationsId', value.map(x => x.id));
                onChange(this.customFilters);
              }}/>
          </Col>
          <Col md={3}>
            <ProductTypeSelector
              multiple
              defaultValue={this.customFilters.productTypesId}
              setValue={value => {
                this.customFilters.productTypesId = value.map(x => x.id)
                sessionStorage.setItem('productTypesId', value.map(x => x.id));
                onChange(this.customFilters);
              }}/>
          </Col>
          <Col md={3}>
            <DispositionSelector
              multiple
              defaultValue={this.customFilters.dispositionsId}
              setValue={value => {
                this.customFilters.dispositionsId = value.map(x => x.id);
                sessionStorage.setItem('dispositionsId', value.map(x => x.id));
                onChange(this.customFilters);
              }}/>
          </Col>
          <Col md={3}>
            <BizStepSelector
              multiple
              defaultValue={this.customFilters.bizStepsId}
              setValue={value => {
                this.customFilters.bizStepsId = value.map(x => x.id);
                sessionStorage.setItem('bizStep', value.map(x => x.id));
                onChange(this.customFilters);
              }}/>
          </Col>

        </Row>
      </div>

    );
  }

  customHeader = (props, state, onChange, refreshState) => {
    this.refreshState = refreshState;
    const listAssetsChecked = state.metadata.getSelectedItems();
    const link = '/transactions/new/';
    return (
      <Link to={{
        pathname: link,
        aboutProps: {
          listAssetsChecked: listAssetsChecked,
        }
      }}>
      </Link>
    )
  };

  selectAll() {
    if (this.state.itemsSelected.length > 0) {
      this.state.itemsSelected = []
    } else {
      this.state.itemsSelected = this.state.allItems
    }
    this.setState({itemsSelected: this.state.itemsSelected})
    this.refreshState && this.refreshState();
  };

  handleChange(assetId) {
    const itemExists = this.state.itemsSelected.includes(assetId)

    if (itemExists) {
      this.state.itemsSelected = this.state.itemsSelected.filter(x => x !== assetId)
    } else {
      this.state.itemsSelected.push(assetId);
    }

    this.setState({itemsSelected: this.state.itemsSelected});
    this.refreshState && this.refreshState();
  }

  getSelectedItems() {
    return this.state.itemsSelected;
  }

  columns = [
    {
      Header: "EPC",
      accessor: "tags.value",
      Cell: (props) => {
        const {tags} = props.original;
        return tags ? tags.map(x => <p key={x.value}><EPCLink epc={x}/></p>) : [];
      },
    },
    {
      Header: "Nome",
      accessor: "productType.friendlyName",
      sortable: false,
      HeaderColumn: true
    },
    {
      Header: "Referência",
      accessor: "productType.reference",
      sortable: false,
    },
    {
      Header: "Localização Atual",
      accessor: "currentState.lsd.bizLocation.friendlyName",
      sortable: false,
    },
    {
      Header: "Disposição Atual",
      accessor: "currentState.lsd.disposition.friendlyName",
      sortable: false,
    },
    {
      Header: "Etapa Atual",
      accessor: "currentState.lsd.bizStep.friendlyName",
      sortable: false,
    },
    {
      Header: "Código do lote",
      accessor: "lot.code",
      sortable: false,
    },
    {
      Header: "Data",
      accessor: "currentState.stateDate",
      isDate: true
,
      Cell: row => (row.original.currentState && dayMonthYearAtTime(row.original.currentState.stateDate))
    }
  ];

  endpoint = (props, state) => {
    const {match, location = {}} = props;

    const bizLocationId = this.customFilters.bizLocationsId;
    const productTypeId = this.customFilters.productTypesId;

    const disposition = this.customFilters.dispositionsId;
    const bizStep = this.customFilters.bizStepsId;

    let query = '?';
    if (Objects.nonEmptyOrBlank(bizLocationId)) {
      query += 'bizLocationsId=' + bizLocationId + '&';
    }
    if (Objects.nonEmptyOrBlank(productTypeId)) {
      query += 'productTypesId=' + productTypeId + '&';
    }
    if (Objects.nonEmptyOrBlank(disposition)) {
      query += 'dispositionsId=' + disposition + '&';
    }
    if (Objects.nonEmptyOrBlank(bizStep)) {
      query += 'bizStepsId=' + bizStep + '&';
    }
    return 'ton/v1/assets' + (query.length > 2 ? query : '');
  }
}



// WEBPACK FOOTER //
// ./src/assets/AssetGrid.js